import { IGetState, TCardId, TCustomPropertyId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { getCardCustomProperties } from '../../../../../../../../store/model/selectors/getCardCustomProperties';
import { cardSetCustomProperties } from '../../../../../../../../rest/effects/card/card/cardSetCustomProperties';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { ICards } from '../../../../../../../../store/model/cards/types';
import { cardsUpdate } from '../../../../../../../../store/model/actionCreators/cardsUpdate';
import { sendAuthUserRealTimeStoreAction } from '../../../../../../base/helpers/realTimeHelperTS';
import {
    getBoardCardCustomProperty
} from '../../../../../../../../store/model/board/selectors/getBoardCardCustomProperty';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { ECustomPropertyType } from '../../../../../../../../store/customProperties/types';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';

export const updateValue = (
    cardId: TCardId,
    id: TCustomPropertyId,
    value: string,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (value === '') value = null;
        const state = getState();
        const cardCustomProperties = {...getCardCustomProperties(state, cardId)};
        const customProperty = cardCustomProperties[id] || {id: id};

        if (
            (value === null && !customProperty.value)
            || customProperty.value === value
        ) {
            return Promise.resolve();
        }

        const boardCustomProperties = getBoardCardCustomProperty(state, getBoardIdByCardId(state, cardId), id);
        if (value === null && boardCustomProperties.type === ECustomPropertyType.DATE) {
            const card = getCard(state, cardId);
            const calendarEvents = card.calendarEvents.filter(event => event.type !== id);
            const cards: ICards = {
                [cardId]: {
                    calendarEvents
                }
            }
            const updateAction = cardsUpdate(cards);
            dispatch(updateAction);
            dispatch(sendAuthUserRealTimeStoreAction(updateAction));
        }

        cardCustomProperties[id] = {
            ...customProperty,
            value,
        };

        dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTY_FILLED));
        return dispatch(cardSetCustomProperties(cardId, cardCustomProperties));
    };
    return action;
};
